import { CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Space } from "antd";
import { useLocation } from "react-router-dom";
import { useGetPackaging } from "@/pages/packaging/usePackagings";

export default function usePackagingDetailTabs({ packagingId }: { packagingId: number }) {
  const location = useLocation();

  const { data } = useGetPackaging({
    packagingId,
  });

  const bomStatus =
    data?.status === "complete" ? (
      <CheckCircleOutlined style={{ color: "#52C41A" }} />
    ) : (
      <InfoCircleOutlined style={{ color: "#FA8C16" }} />
    );

  const tabs = [
    {
      key: "relations",
      label: (
        <Space>
          <span>Relations</span>
        </Space>
      ),
    },
    {
      key: "bom",
      label: (
        <Space>
          {bomStatus}
          <span>Bill of materials</span>
        </Space>
      ),
    },
  ];

  const locationTab = location.pathname.split("/")[3];
  const activeTab = tabs.find((item) => item.key === locationTab)?.key || tabs[0].key;

  return { tabs, activeTab };
}
